import React from 'react'
import { PrismicLink } from '@prismicio/react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const CategoryCard = ({ item }) => {
  const itemData = item.node.data
  const authorData = itemData.author?.document.data
  const publishDate = item.node.last_publication_date_formatted
  let timeToRead

  if (item.node.type === 'blogpost') {
    const wordsPerMinute = 200
    let wordCount = itemData.page_text?.text.split(' ').length
    timeToRead = Math.ceil(wordCount / wordsPerMinute)
  }
  return (
    <li className='component-card ease relative flex transform flex-col overflow-hidden rounded-md bg-white group transition duration-300 ease-in-out hover:scale-105 dark:bg-transparent'>
      <PrismicLink className='flex flex-1 flex-col' href={item.node.url}>
        <div className='relative flex-shrink-0'>
          <GatsbyImage className='rounded-md' image={getImage(itemData.page_image)} alt={itemData.page_image.alt || ''} />
        </div>
        <div className='flex flex-1 flex-col m-2'>
          <div className='mb-6 space-y-4'>
            <h3 className='group-hover:text-brandBlue group-hover:dark:text-brandYellow'>{itemData.page_title.text}</h3>
            <div className='mb-6 mt-3 text-lg text-slate-500 dark:text-slate-100'>
              {itemData.page_text.text.split(' ').slice(0, 30).join(' ')}
              &hellip;
            </div>
          </div>
          {authorData && (
            <div className='mt-auto flex items-center'>
              {authorData.image.gatsbyImageData && (
                <div className='relative mr-3 flex-shrink-0 rounded-md p-1 bg-brandYellow border-brandYellow border'>
                  <GatsbyImage className='h-10 w-10' image={authorData.image.gatsbyImageData} alt={authorData.image.alt || ''} />
                </div>
              )}
              <div>
                <p className='font-semibold text-base xl:text-lg text-slate-900 dark:text-slate-50'>{authorData.name}</p>
                <div className='flex space-x-1 text-base text-slate-500 dark:text-slate-100'>
                  {publishDate} &middot; {timeToRead} min read
                </div>
              </div>
            </div>
          )}
        </div>
      </PrismicLink>
    </li>
  )
}

export default CategoryCard
